<app-header></app-header>
  <div class="p-outlet" [@routerAnimation]="o.isActivated ? o.activatedRoute : ''">
    <router-outlet #o="outlet"></router-outlet>
  </div>
<app-footer></app-footer>

<app-background />
